import { Grid, Box, Button } from "@mui/material"
import Typography from "@mui/material/Typography"
import TextField from "@mui/material/TextField"
import { Stack, CircularProgress, Modal } from "@mui/material"

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 20,
    p: 4,
    minWidth: 750,
    maxWidth: 750,
    borderRadius: 3,
    position: "relative"
};

export default function ExportModal({
    openExport,
    handleCloseExport,
    spinerModalExport,
    msgDangerModalExport,
    dateExportStart,
    setDateExportStart,
    dateExportEnd,
    setDateExportEnd,
    createExport
}) {
    return (
        <Modal
            open={openExport}
            onClose={handleCloseExport}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="text-center"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    Exportar Facturas
                </Typography>
                {!spinerModalExport && (
                    <>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Seleccione un rango de fechas:
                        </Typography>

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                                <div className="mt-2">
                                    <TextField
                                        name="dateExportStart"
                                        label="Desde"
                                        variant="outlined"
                                        type="date"
                                        format="dd/MM/yyyy"
                                        fullWidth
                                        onChange={(e) => setDateExportStart(e.target.value)}
                                        value={dateExportStart || []}
                                        InputLabelProps={{ shrink: true }}
                                        size="small"
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <div className="mt-2">
                                    <TextField
                                        name="dateExportEnd"
                                        label="Hasta"
                                        variant="outlined"
                                        type="date"
                                        format="dd/MM/yyyy"
                                        fullWidth
                                        onChange={(e) => setDateExportEnd(e.target.value)}
                                        value={dateExportEnd || []}
                                        InputLabelProps={{ shrink: true }}
                                        size="small"
                                    />
                                </div>
                            </Grid>
                        </Grid>
                        {msgDangerModalExport && (
                            <Grid item xs={12} md={12} lg={12} mt={4}>
                                <Box className="alert-danger">
                                    {msgDangerModalExport.map((item, index) => {
                                        return (<span key={index}>{item} <br /></span>)
                                    })}
                                </Box>
                            </Grid>
                        )}
                        <Stack direction="row" justifyContent="space-between" mt={4}>
                            <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16 }}>
                                <div style={{ width: "50%" }}>
                                    <Button
                                        onClick={handleCloseExport}
                                        variant="contained"
                                        className="MuiButton-containedCancel"
                                        fullWidth
                                    >
                                        Cancelar
                                    </Button>
                                </div>
                                <div style={{ width: "50%" }}>
                                    <Button
                                        onClick={createExport}
                                        color="primary"
                                        variant="contained"
                                        fullWidth
                                    >
                                        Exportar
                                    </Button>
                                </div>
                            </div>

                        </Stack>
                    </>
                )}
                {spinerModalExport && (
                    <>
                        <br />
                        <br />
                        <br />
                        <CircularProgress color="success" />
                        <br />
                        <br />
                        <br />
                    </>
                )}
            </Box>
        </Modal>
    );
}
